export const roadmapData = [
  {
    name: "FASE 1 & 2: Core y Visual",
    tasks: [
      {
        id: "1-2.1",
        name: "Panel Admin Web estable",
        status: "testing",
        description: "Tu 'oficina virtual' de FIXARR. Una web donde gestionas TODO el negocio: servicios pendientes, técnicos, clientes y agenda. Como un asistente que te muestra qué hay para hoy, quién está libre y qué falta por cobrar.",
        tech: "React 18, Supabase",
        time: "3-4 semanas",
        estimatedTime: 180,
        checklist: [
          { id: 1, text: "Login funciona correctamente en panel.fixarr.es" },
          { id: 2, text: "Dashboard muestra métricas actualizadas" },
          { id: 3, text: "Navegación entre secciones sin errores" },
          { id: 4, text: "Datos se cargan en menos de 3 segundos" },
          { id: 5, text: "Sin errores en consola del navegador" }
        ]
      },
      {
        id: "1-2.2",
        name: "Diseño responsive",
        status: "testing",
        description: "El panel se adapta a cualquier pantalla: ordenador, tablet o móvil. Puedes reasignar un servicio desde el sofá con tu teléfono sin encender el ordenador.",
        tech: "CSS Grid, Media Queries",
        time: "1-2 semanas",
        estimatedTime: 60,
        checklist: [
          { id: 1, text: "Probar en móvil (375px) - menú funciona" },
          { id: 2, text: "Probar en tablet (768px) - layout correcto" },
          { id: 3, text: "Probar en desktop (1920px) - sin overflow" },
          { id: 4, text: "Tablas se adaptan o tienen scroll horizontal" },
          { id: 5, text: "Modales se ven correctos en móvil" }
        ]
      },
      {
        id: "1-2.3",
        name: "Branding finalizado",
        status: "testing",
        description: "Identidad visual profesional: logo FIXARR, colores corporativos (azul y dorado), tipografías. Todo se ve igual en emails, facturas y web = confianza del cliente.",
        tech: "SVG, CSS Variables",
        time: "2-3 semanas",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Logo FIXARR visible en header" },
          { id: 2, text: "Colores corporativos consistentes (azul/dorado)" },
          { id: 3, text: "Tipografía Inter o similar aplicada" },
          { id: 4, text: "Favicon actualizado con logo" },
          { id: 5, text: "Emails con branding correcto" }
        ]
      },
      {
        id: "1-2.4",
        name: "Gestión de Clientes",
        status: "testing",
        description: "Base de datos completa de clientes: nombre, teléfono, email, múltiples direcciones, historial de servicios. Buscador rápido y formularios de alta/edición.",
        tech: "React, Supabase",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Crear cliente nuevo con todos los campos" },
          { id: 2, text: "Editar cliente existente" },
          { id: 3, text: "Buscar cliente por nombre/teléfono" },
          { id: 4, text: "Ver historial de servicios del cliente" },
          { id: 5, text: "Añadir múltiples direcciones a un cliente" }
        ]
      },
      {
        id: "1-2.5",
        name: "Gestión de Equipo/Técnicos",
        status: "testing",
        description: "Panel para gestionar técnicos: crear perfiles, asignar zonas de trabajo, ver disponibilidad, gestionar horarios y permisos. Papelera de reciclaje para soft-delete.",
        tech: "React, RLS Supabase",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Crear técnico nuevo con foto y datos" },
          { id: 2, text: "Asignar códigos postales al técnico" },
          { id: 3, text: "Eliminar técnico (soft-delete a papelera)" },
          { id: 4, text: "Restaurar técnico desde papelera" },
          { id: 5, text: "Ver calendario/disponibilidad del técnico" }
        ]
      },
      {
        id: "1-2.6",
        name: "Creación de Tickets/Servicios",
        status: "testing",
        description: "Formulario completo para crear servicios: seleccionar cliente, dirección, electrodoméstico, marca, descripción del problema, fecha preferida. Validaciones y confirmación.",
        tech: "React Modals, Supabase",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Crear ticket seleccionando cliente existente" },
          { id: 2, text: "Seleccionar dirección del cliente" },
          { id: 3, text: "Elegir electrodoméstico y marca" },
          { id: 4, text: "Describir problema y guardar" },
          { id: 5, text: "Ticket aparece en monitor de servicios" }
        ]
      },
      {
        id: "1-2.7",
        name: "Monitor de Servicios",
        status: "testing",
        description: "Vista en tiempo real de todos los servicios: pendientes, en proceso, completados. Filtros por estado, técnico, fecha. Actualización automática cuando cambia algo.",
        tech: "Supabase Realtime",
        time: "1-2 semanas",
        estimatedTime: 60,
        checklist: [
          { id: 1, text: "Ver lista de todos los servicios" },
          { id: 2, text: "Filtrar por estado (pendiente/asignado/completado)" },
          { id: 3, text: "Filtrar por técnico" },
          { id: 4, text: "Actualización automática sin recargar" },
          { id: 5, text: "Click en servicio abre detalles" }
        ]
      },
      {
        id: "1-2.8",
        name: "Sistema Mortify (Reputación técnicos)",
        status: "testing",
        description: "Sistema de puntuación para técnicos. Evalúa puntualidad, calidad del trabajo y opiniones de clientes. Ves rankings y métricas para saber quiénes son tus mejores técnicos.",
        tech: "PostgreSQL, React Dashboard",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Ver puntuación de cada técnico" },
          { id: 2, text: "Ranking ordenado por puntuación" },
          { id: 3, text: "Métricas de puntualidad visibles" },
          { id: 4, text: "Reseñas de clientes afectan puntuación" }
        ]
      },
      {
        id: "1-2.9",
        name: "Fleet Tracking Mapbox (GPS tiempo real)",
        status: "testing",
        description: "Mapa interactivo donde ves la ubicación de todos los técnicos en tiempo real. Sabes quién está cerca de un cliente nuevo y cuánto tardará en llegar.",
        tech: "Mapbox GL JS, Geolocation API",
        time: "2-3 semanas",
        estimatedTime: 120,
        checklist: [
          { id: 1, text: "Mapa carga correctamente" },
          { id: 2, text: "Técnicos aparecen como marcadores" },
          { id: 3, text: "Ubicación se actualiza en tiempo real" },
          { id: 4, text: "Click en técnico muestra info" }
        ]
      },
      {
        id: "1-2.10",
        name: "Sistema de Presupuestos",
        status: "testing",
        description: "Crea presupuestos, envíalos al cliente por email/WhatsApp, y cuando aceptan: se convierte en servicio automáticamente. Flujo completo: crear → enviar → aprobar → servicio.",
        tech: "React Modals, PDF, Email",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Crear presupuesto con líneas de detalle" },
          { id: 2, text: "Generar PDF del presupuesto" },
          { id: 3, text: "Enviar presupuesto por email" },
          { id: 4, text: "Cliente acepta → genera servicio" }
        ]
      },
      {
        id: "1-2.11",
        name: "Registro de Presupuestos",
        status: "testing",
        description: "Historial completo de todos los presupuestos: pendientes, aceptados, rechazados. Filtros, búsqueda y acceso rápido para dar seguimiento.",
        tech: "React, PostgreSQL",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Ver lista de todos los presupuestos" },
          { id: 2, text: "Filtrar por estado" },
          { id: 3, text: "Buscar por cliente" },
          { id: 4, text: "Ver detalles de presupuesto" }
        ]
      },
      {
        id: "1-2.12",
        name: "Gestión de Marcas/Electrodomésticos",
        status: "testing",
        description: "Catálogo de todas las marcas y tipos de electrodomésticos que reparas: Bosch, Samsung, lavadoras, frigoríficos... Con logos y categorías organizadas.",
        tech: "PostgreSQL, React CRUD",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Ver lista de marcas" },
          { id: 2, text: "Añadir nueva marca con logo" },
          { id: 3, text: "Editar marca existente" },
          { id: 4, text: "Marcas aparecen en creación de tickets" }
        ]
      },
      {
        id: "1-2.13",
        name: "Tipos de Electrodomésticos",
        status: "testing",
        description: "Catálogo de tipos de aparatos: lavadoras, frigoríficos, hornos, lavavajillas... Cada tipo con su icono y características. Usado en la creación de tickets.",
        tech: "PostgreSQL, React",
        time: "3-5 días",
        estimatedTime: 30,
        checklist: [
          { id: 1, text: "Ver lista de tipos de electrodomésticos" },
          { id: 2, text: "Añadir nuevo tipo con icono" },
          { id: 3, text: "Tipos aparecen en creación de tickets" }
        ]
      },
      {
        id: "1-2.14",
        name: "Gestión de Materiales/Inventario",
        status: "testing",
        description: "Control de repuestos y materiales: stock disponible, pedidos, precios. Sabes qué piezas tienes y cuáles hay que pedir.",
        tech: "PostgreSQL, React",
        time: "1-2 semanas",
        estimatedTime: 60,
        checklist: [
          { id: 1, text: "Ver lista de materiales en stock" },
          { id: 2, text: "Añadir material nuevo" },
          { id: 3, text: "Actualizar cantidad en stock" },
          { id: 4, text: "Ver materiales con stock bajo" }
        ]
      },
      {
        id: "1-2.15",
        name: "Tech Route Progress",
        status: "testing",
        description: "Ves la ruta diaria de cada técnico: qué servicios ha completado, cuál está haciendo ahora y cuáles le faltan. Como un timeline visual del día.",
        tech: "React Components, Realtime",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Ver ruta del día del técnico" },
          { id: 2, text: "Servicios completados marcados" },
          { id: 3, text: "Servicio actual destacado" },
          { id: 4, text: "Tiempo estimado restante visible" }
        ]
      },
      {
        id: "1-2.16",
        name: "Analytics Dashboard",
        status: "testing",
        description: "Gráficos y estadísticas del negocio: ingresos mensuales, servicios por zona, rendimiento por técnico, tendencias. Sabes cómo va el negocio de un vistazo.",
        tech: "Chart.js, PostgreSQL",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Gráfico de ingresos mensuales" },
          { id: 2, text: "Servicios por zona/código postal" },
          { id: 3, text: "Rendimiento por técnico" },
          { id: 4, text: "Métricas actualizadas en tiempo real" }
        ]
      },
      {
        id: "1-2.17",
        name: "Smart Assignment",
        status: "testing",
        description: "Asignación inteligente de técnicos. El sistema considera: quién está más cerca, quién tiene hueco, quién se especializa en esa marca, quién tiene mejor puntuación.",
        tech: "PostgreSQL RPC, Algorithm",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Sugerencia de técnico por proximidad" },
          { id: 2, text: "Considera disponibilidad en agenda" },
          { id: 3, text: "Muestra puntuación del técnico" },
          { id: 4, text: "Asignación con un click" }
        ]
      },
      {
        id: "1-2.18",
        name: "Firma Digital",
        status: "testing",
        description: "Captura de firma del cliente en pantalla táctil. El técnico obtiene la firma de conformidad directamente en su app. Se guarda en el servicio.",
        tech: "Canvas, Supabase Storage",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Canvas de firma funciona en app técnico" },
          { id: 2, text: "Firma se guarda en Supabase Storage" },
          { id: 3, text: "Firma visible en detalle del servicio" }
        ]
      },
      {
        id: "1-2.19",
        name: "Envío de PDFs por Email",
        status: "testing",
        description: "Sistema para enviar presupuestos, facturas y garantías en PDF directamente al email del cliente. Con diseño profesional y logo FIXARR.",
        tech: "Edge Functions, Email API",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Generar PDF de presupuesto" },
          { id: 2, text: "PDF tiene logo FIXARR" },
          { id: 3, text: "Envío de email funciona (Resend)" },
          { id: 4, text: "Cliente recibe email con PDF adjunto" }
        ]
      },
      {
        id: "1-2.20",
        name: "Sistema de Permisos/Roles",
        status: "testing",
        description: "Control de acceso por rol: admin ve todo, coordinador ve agenda, técnico solo sus servicios. Cada usuario accede solo a lo que le corresponde.",
        tech: "RLS Supabase, React Guards",
        time: "1-2 semanas",
        estimatedTime: 60,
        checklist: [
          { id: 1, text: "Admin accede a todas las secciones" },
          { id: 2, text: "Técnico solo ve sus servicios" },
          { id: 3, text: "RLS activo en todas las tablas" }
        ]
      },
      {
        id: "1-2.21",
        name: "Configuración del Negocio",
        status: "testing",
        description: "Panel de ajustes: datos de la empresa, horarios de trabajo, días festivos, tarifas, plantillas de mensajes. Todo configurable sin tocar código.",
        tech: "React, PostgreSQL",
        time: "1-2 semanas",
        estimatedTime: 60,
        checklist: [
          { id: 1, text: "Editar datos de empresa" },
          { id: 2, text: "Configurar horarios de trabajo" },
          { id: 3, text: "Añadir días festivos" },
          { id: 4, text: "Cambios se guardan correctamente" }
        ]
      },
      {
        id: "1-2.22",
        name: "Sistema de Reseñas de Clientes",
        status: "testing",
        description: "Los clientes pueden valorar el servicio con estrellas y comentarios. Las reseñas se asocian al técnico y afectan su puntuación Mortify.",
        tech: "PostgreSQL, React",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Cliente puede dejar valoración" },
          { id: 2, text: "Estrellas y comentario guardados" },
          { id: 3, text: "Reseña aparece en perfil técnico" },
          { id: 4, text: "Puntuación Mortify se actualiza" }
        ]
      },
      {
        id: "1-2.23",
        name: "App Técnicos Flutter",
        status: "testing",
        description: "Aplicación móvil para técnicos: ven su agenda del día, detalles de cada servicio, actualizan estado, suben fotos y obtienen firma del cliente.",
        tech: "Flutter, Supabase",
        time: "3-4 semanas",
        estimatedTime: 180,
        checklist: [
          { id: 1, text: "App abre sin errores en Android" },
          { id: 2, text: "Login de técnico funciona" },
          { id: 3, text: "Ver agenda del día" },
          { id: 4, text: "Cambiar estado del servicio" },
          { id: 5, text: "Subir foto del trabajo" },
          { id: 6, text: "Obtener firma del cliente" }
        ]
      },
      {
        id: "1-2.24",
        name: "App Clientes Flutter",
        status: "testing",
        description: "Aplicación móvil para clientes: solicitan servicios, ven estado en tiempo real, tracking del técnico en mapa, historial y pagos.",
        tech: "Flutter, Supabase",
        time: "3-4 semanas",
        estimatedTime: 180,
        checklist: [
          { id: 1, text: "App abre sin errores en Android" },
          { id: 2, text: "Registro de nuevo cliente" },
          { id: 3, text: "Solicitar servicio desde app" },
          { id: 4, text: "Ver estado del servicio en tiempo real" },
          { id: 5, text: "Ver ubicación del técnico en mapa" },
          { id: 6, text: "Ver historial de servicios" }
        ]
      }
    ]
  },
  {
    name: "FASE 3: Automatización e Inteligencia - Secretaria Virtual PRO",
    tasks: [
      {
        id: "3.0",
        name: "Rutas: Asignación por código postal",
        status: "testing",
        description: "Cada técnico tiene definidas sus zonas (por código postal). Cliente en 29001 → Sistema solo muestra técnicos que cubren esa zona. Evita viajes de 50km innecesarios.",
        tech: "PostgreSQL, Supabase RPC",
        time: "3-5 días",
        estimatedTime: 30,
        checklist: [
          { id: 1, text: "Técnico tiene CPs asignados en su perfil" },
          { id: 2, text: "Solo técnicos de zona aparecen en asignación" },
          { id: 3, text: "CP sin cobertura muestra alerta" }
        ]
      },
      {
        id: "3.1",
        name: "Motor de Viabilidad",
        status: "testing",
        description: "Verificador automático: ¿Hay técnico en esa zona? ¿Tiene hueco a esa hora? ¿Le da tiempo de llegar desde el servicio anterior? Si no es viable, lo dice antes de aceptar.",
        tech: "PostgreSQL RPC",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Detecta si hay técnico en zona" },
          { id: 2, text: "Verifica disponibilidad de horario" },
          { id: 3, text: "Calcula tiempo de viaje entre servicios" },
          { id: 4, text: "Muestra mensaje si no viable" }
        ]
      },
      {
        id: "3.2",
        name: "Conexión WhatsApp META API",
        status: "testing",
        description: "Integración oficial con WhatsApp Business. El sistema envía/recibe mensajes automáticamente: confirmaciones, recordatorios, y el bot conversacional. Funciona 24/7.",
        tech: "Meta Cloud API, Edge Functions",
        time: "1-2 semanas",
        estimatedTime: 60,
        checklist: [
          { id: 1, text: "Webhook recibe mensajes de WhatsApp" },
          { id: 2, text: "Envío de mensaje funciona" },
          { id: 3, text: "Token de Meta configurado en Supabase" },
          { id: 4, text: "Logs de mensajes visibles" }
        ]
      },
      {
        id: "3.3.1",
        name: "Base datos multi-dirección",
        status: "testing",
        description: "Un cliente puede tener varias direcciones guardadas (casa, oficina, apartamento). Cuando pide servicio, elige con 1 click en vez de escribir todo de nuevo.",
        tech: "PostgreSQL, Foreign Keys",
        time: "3-5 días",
        estimatedTime: 30,
        checklist: [
          { id: 1, text: "Cliente puede tener múltiples direcciones" },
          { id: 2, text: "Direcciones aparecen en perfil cliente" },
          { id: 3, text: "Bot muestra direcciones para elegir" }
        ]
      },
      {
        id: "3.3.2",
        name: "Reconocimiento de cliente",
        status: "testing",
        description: "El sistema identifica automáticamente si el número que escribe ya es cliente. Si es conocido: 'Hola de nuevo Juan!' y salta las preguntas que ya tiene guardadas.",
        tech: "Supabase Queries",
        time: "2-3 días",
        estimatedTime: 20,
        checklist: [
          { id: 1, text: "Bot reconoce cliente existente" },
          { id: 2, text: "Saludo personalizado con nombre" },
          { id: 3, text: "No pide datos ya guardados" }
        ]
      },
      {
        id: "3.3.3",
        name: "Bot conversacional",
        status: "testing",
        description: "Secretaria virtual 24/7. Guía al cliente paso a paso: recoge nombre, dirección, electrodoméstico, problema y crea el servicio automáticamente. Atiende 100 clientes a la vez.",
        tech: "State Machine, Edge Functions",
        time: "2 semanas",
        estimatedTime: 90,
        checklist: [
          { id: 1, text: "Bot inicia conversación correctamente" },
          { id: 2, text: "Recoge nombre del cliente" },
          { id: 3, text: "Recoge dirección" },
          { id: 4, text: "Recoge tipo de electrodoméstico" },
          { id: 5, text: "Recoge descripción del problema" },
          { id: 6, text: "Crea ticket automáticamente" }
        ]
      },
      {
        id: "3.3.4",
        name: "Validación teléfono único",
        status: "testing",
        description: "Cada número de teléfono solo puede estar registrado una vez. Evita duplicados y mantiene todo el historial del cliente en un único perfil.",
        tech: "PostgreSQL UNIQUE",
        time: "1-2 días",
        estimatedTime: 15,
        checklist: [
          { id: 1, text: "No permite teléfonos duplicados" },
          { id: 2, text: "Error claro si intenta duplicar" },
          { id: 3, text: "Constraint UNIQUE en tabla" }
        ]
      },
      {
        id: "3.3.5",
        name: "Notificación ON_ASSIGN",
        status: "testing",
        description: "Cuando asignas técnico, el cliente recibe WhatsApp INMEDIATO: 'Técnico María, mañana 10:00'. Cliente queda tranquilo sin llamar a preguntar.",
        tech: "WhatsApp API, Triggers",
        time: "2-3 días",
        estimatedTime: 20,
        checklist: [
          { id: 1, text: "Asignar técnico envía WhatsApp" },
          { id: 2, text: "Mensaje contiene nombre técnico" },
          { id: 3, text: "Mensaje contiene fecha y hora" }
        ]
      },
      {
        id: "3.3.6",
        name: "Recordatorio 24h antes",
        status: "testing",
        description: "Sistema envía recordatorio automático un día antes: 'Mañana tienes cita a las 10:00'. Reduce un 70% las ausencias de clientes que se olvidan.",
        tech: "Cron Jobs, WhatsApp API",
        time: "2-3 días",
        estimatedTime: 20,
        checklist: [
          { id: 1, text: "Cron job ejecuta diariamente" },
          { id: 2, text: "Recordatorio enviado 24h antes" },
          { id: 3, text: "Mensaje contiene fecha y hora correctas" }
        ]
      },
      {
        id: "3.3.7",
        name: "Notif. actualización estado",
        status: "testing",
        description: "Cliente recibe updates automáticos: 'Técnico en camino' → 'Técnico ha llegado' → 'Servicio completado'. Como cuando pides comida y ves el progreso.",
        tech: "Database Triggers",
        time: "2-3 días",
        estimatedTime: 20,
        checklist: [
          { id: 1, text: "Notificación al cambiar a 'en camino'" },
          { id: 2, text: "Notificación al 'llegar'" },
          { id: 3, text: "Notificación al 'completar'" }
        ]
      },
      {
        id: "3.3.7b",
        name: "Notificación ON_DEPARTURE",
        status: "testing",
        description: "Cuando el técnico sale hacia el cliente, se envía automáticamente: 'Tu técnico está en camino, llegará en X minutos'. Con ETA calculado.",
        tech: "Edge Functions, GPS",
        time: "2-3 días",
        estimatedTime: 20,
        checklist: [
          { id: 1, text: "Técnico marca 'salir' en app" },
          { id: 2, text: "Cliente recibe WhatsApp con ETA" },
          { id: 3, text: "ETA calculado correctamente" }
        ]
      },
      {
        id: "3.3.8",
        name: "Agenda Global UI",
        status: "testing",
        description: "Calendario visual con TODOS los servicios de TODOS los técnicos. Ves de un vistazo quién tiene hueco, quién está ocupado, y puedes asignar arrastrando.",
        tech: "React Calendar, Realtime",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Ver todos los técnicos en agenda" },
          { id: 2, text: "Ver servicios de cada técnico" },
          { id: 3, text: "Huecos libres visibles" },
          { id: 4, text: "Actualización en tiempo real" }
        ]
      },
      {
        id: "3.3.8b",
        name: "Peticiones Entrantes",
        status: "testing",
        description: "Vista dedicada para ver todas las solicitudes nuevas que llegan por WhatsApp o App. Puedes aceptarlas, rechazarlas o asignarlas rápidamente.",
        tech: "React, Realtime",
        time: "3-5 días",
        estimatedTime: 30,
        checklist: [
          { id: 1, text: "Ver lista de peticiones nuevas" },
          { id: 2, text: "Aceptar petición funciona" },
          { id: 3, text: "Rechazar petición funciona" },
          { id: 4, text: "Actualización automática" }
        ]
      },
      {
        id: "3.3.8c",
        name: "Configuración Secretaria Virtual",
        status: "testing",
        description: "Panel completo para configurar el bot: mensajes personalizados, horarios de atención, respuestas automáticas, plantillas de WhatsApp.",
        tech: "React, PostgreSQL",
        time: "1 semana",
        estimatedTime: 45,
        checklist: [
          { id: 1, text: "Acceder a configuración del bot" },
          { id: 2, text: "Editar mensaje de bienvenida" },
          { id: 3, text: "Configurar horarios de atención" },
          { id: 4, text: "Cambios guardados correctamente" }
        ]
      },
      {
        id: "3.3.9",
        name: "Bot PRO negociación de citas",
        status: "testing",
        description: "El bot propone citas automáticamente al cliente SIN intervención humana. 'Tenemos hueco mañana a las 10, 14 o 17. ¿Cuál prefieres?' Cliente elige y queda reservado.",
        tech: "Edge Functions, Algorithm",
        time: "2 semanas",
        checklist: [
          { id: 1, text: "Verificar Edge Function ticket-autopilot-processor desplegada" },
          { id: 2, text: "Crear ticket desde App Cliente" },
          { id: 3, text: "Confirmar que llegan opciones de cita en menos de 60s" },
          { id: 4, text: "Verificar que las opciones muestran fecha y hora correctas" }
        ]
      },
      {
        id: "3.3.10",
        name: "Consulta agenda (3 huecos)",
        status: "testing",
        description: "Función que busca los próximos 7 días y ofrece las mejores opciones al cliente. 'Regla de Oro': ofrece 1, 2 o 3 opciones según disponibilidad real.",
        tech: "PostgreSQL RPC",
        time: "1 semana",
        checklist: [
          { id: 1, text: "Crear segundo técnico con CP diferente en Panel Admin" },
          { id: 2, text: "Verificar que ambos técnicos aparecen en propuestas de cita" },
          { id: 3, text: "Probar Regla de Oro: con pocos huecos ofrece 1 opción" },
          { id: 4, text: "Probar Regla de Oro: con muchos huecos ofrece 3 opciones" },
          { id: 5, text: "Verificar cálculo de tiempo de viaje entre CPs" }
        ]
      },
      {
        id: "3.3.11",
        name: "Reserva automática",
        status: "testing",
        description: "Cliente elige opción → Sistema reserva el hueco inmediatamente → Asigna técnico → Actualiza agenda. Todo en 2 segundos sin que tú hagas nada.",
        tech: "Transactions, Locking",
        time: "1 semana",
        checklist: [
          { id: 1, text: "Cliente selecciona opción de cita" },
          { id: 2, text: "Verificar que ticket cambia a 'programado' en menos de 3s" },
          { id: 3, text: "Confirmar técnico asignado correctamente" },
          { id: 4, text: "Ver cita en Agenda Global del Panel Admin" },
          { id: 5, text: "Verificar que no hay doble reserva del mismo hueco" }
        ]
      },
      {
        id: "3.3.12",
        name: "Autopilot Total optimización",
        status: "testing",
        description: "Sistema híbrido: webhook inmediato + cron cada 30s. Procesa tickets nuevos al instante, aplica timeout de 3 min, limpia propuestas expiradas. Autopilot total.",
        tech: "Cron, Webhooks",
        time: "1-2 semanas",
        checklist: [
          { id: 1, text: "Crear ticket y verificar propuestas en menos de 60s" },
          { id: 2, text: "NO responder y esperar timeout (3 min)" },
          { id: 3, text: "Verificar que propuesta expira correctamente" },
          { id: 4, text: "Confirmar que ticket vuelve a procesarse automáticamente" }
        ]
      },
      {
        id: "3.3.13",
        name: "Pruebas Bot PRO via App Cliente",
        status: "testing",
        description: "Validación completa del flujo Bot PRO usando la aplicación Flutter. Probado: creación de tickets, propuestas de citas, confirmaciones y reservas.",
        tech: "Flutter App, Testing",
        time: "3-5 días",
        checklist: [
          { id: 1, text: "Instalar App Cliente Flutter en móvil Android" },
          { id: 2, text: "Registrar nuevo usuario con teléfono real" },
          { id: 3, text: "Crear ticket completo (dirección, electrodoméstico, problema)" },
          { id: 4, text: "Recibir propuestas de cita en la app" },
          { id: 5, text: "Seleccionar una opción y confirmar reserva" },
          { id: 6, text: "Verificar ticket programado en Panel Admin" },
          { id: 7, text: "Probar rechazo de propuestas y recibir nuevas opciones" }
        ]
      }
    ]
  },
  {
    name: "FASE 4: Web Comercial fixarr.es",
    tasks: [
      {
        id: "4.1",
        name: "Landing Page",
        status: "pending",
        description: "Página principal de marketing: quiénes somos, qué reparamos, por qué elegirnos, testimonios de clientes, y botón grande para solicitar servicio.",
        tech: "Next.js, SEO",
        time: "1-2 semanas"
      },
      {
        id: "4.2",
        name: "Blog",
        status: "pending",
        description: "Artículos sobre mantenimiento de electrodomésticos: 'Cómo alargar la vida de tu lavadora', 'Cuándo cambiar el frigorífico'. Mejora SEO y posicionamiento en Google.",
        tech: "MDX, CMS",
        time: "1 semana"
      },
      {
        id: "4.3",
        name: "Pricing público",
        status: "pending",
        description: "Página con precios transparentes: visita 30€, reparación lavadora desde X€. Cliente ve precios claros ANTES de llamar = más confianza.",
        tech: "React, Tablas",
        time: "3-5 días"
      },
      {
        id: "4.4",
        name: "Portal clientes público",
        status: "pending",
        description: "Área donde clientes entran con su teléfono y ven: sus servicios, historial, facturas y garantías descargables. Autoservicio 24/7.",
        tech: "Auth, Protected Routes",
        time: "1-2 semanas"
      },
      {
        id: "4.5",
        name: "SEO optimización",
        status: "pending",
        description: "Optimización para Google: aparecer primero cuando alguien busca 'reparar lavadora Málaga'. Meta tags, velocidad, Core Web Vitals verdes.",
        tech: "Next.js SEO, Lighthouse",
        time: "1 semana"
      },
      {
        id: "4.6",
        name: "Lanzamiento Meta Business - WhatsApp público",
        status: "pending",
        description: "Verificar empresa en Meta Business, aprobar plantillas de mensajes, y habilitar WhatsApp para CUALQUIER número (no solo los de prueba).",
        tech: "Meta Business Manager",
        time: "1-2 semanas",
        highlight: true
      }
    ]
  },
  {
    name: "FASE 4.5: Pruebas Bot PRO WhatsApp Real",
    tasks: [
      {
        id: "4.5.1",
        name: "Pruebas Bot PRO con WhatsApp público",
        status: "pending",
        description: "Probar el Bot PRO con clientes REALES vía WhatsApp (no números de prueba). Validar que todo funciona en producción con cualquier persona que escriba.",
        tech: "WhatsApp API, Production",
        time: "1 semana",
        highlight: true
      },
      {
        id: "4.5.2",
        name: "Ajustes conversacionales según feedback",
        status: "pending",
        description: "Mejorar mensajes del bot según lo que digan los usuarios reales: ¿se entiende bien? ¿responde rápido? ¿falta alguna opción? Ajustar y optimizar.",
        tech: "Copy optimization, UX",
        time: "3-5 días"
      },
      {
        id: "4.5.3",
        name: "Validación flujo cliente nuevo",
        status: "pending",
        description: "Probar completo el flujo para clientes que contactan POR PRIMERA VEZ: registro, datos, dirección, electrodoméstico, GDPR, creación de ticket.",
        tech: "End-to-end testing",
        time: "2-3 días"
      },
      {
        id: "4.5.4",
        name: "Validación flujo cliente existente",
        status: "pending",
        description: "Probar el flujo para clientes YA REGISTRADOS: ¿los reconoce? ¿les muestra sus direcciones? ¿proceso rápido? Validar que funciona perfecto.",
        tech: "End-to-end testing",
        time: "2-3 días"
      },
      {
        id: "4.5.5",
        name: "Optimización tiempos de respuesta",
        status: "pending",
        description: "Ajustar velocidad: el bot debe responder en menos de 3 segundos. Optimizar Edge Functions, timeouts y experiencia de usuario.",
        tech: "Performance, Edge Functions",
        time: "2-3 días"
      }
    ],
    isNew: true
  },
  {
    name: "FASE 5: Pasarelas de Pago Reales",
    tasks: [
      {
        id: "5.1",
        name: "Stripe checkout",
        status: "pending",
        description: "Pago con tarjeta de crédito/débito. Cliente recibe link de pago, introduce tarjeta, y el dinero llega a tu cuenta. Seguro y profesional.",
        tech: "Stripe API, Webhooks",
        time: "1-2 semanas"
      },
      {
        id: "5.2",
        name: "Bizum",
        status: "pending",
        description: "Pago con Bizum, muy popular en España. Cliente paga desde su móvil en 10 segundos. Comodidad máxima.",
        tech: "Redsys/Bizum API",
        time: "1 semana"
      },
      {
        id: "5.3",
        name: "Transferencia",
        status: "pending",
        description: "Pago por transferencia bancaria con referencia única. Cliente hace transferencia, sistema la detecta y marca como pagado.",
        tech: "IBAN validation",
        time: "3-5 días"
      },
      {
        id: "5.4",
        name: "Webhooks pago",
        status: "pending",
        description: "Sistema que recibe confirmación automática de pagos (Stripe, Bizum) y actualiza el estado del servicio a 'Pagado' sin intervención manual.",
        tech: "Edge Functions",
        time: "3-5 días"
      },
      {
        id: "5.5",
        name: "Gestión reembolsos",
        status: "pending",
        description: "Proceso para devolver dinero si hay cancelación o problema. Cliente solicita → lo apruebas → dinero vuelve automáticamente.",
        tech: "Stripe Refunds",
        time: "3-5 días"
      },
      {
        id: "5.6",
        name: "TPV físico",
        status: "pending",
        description: "Datáfono portátil para que técnicos cobren en casa del cliente. Pago con tarjeta física en el momento. SumUp o iZettle.",
        tech: "SumUp API",
        time: "1-2 semanas"
      }
    ]
  },
  {
    name: "FASE 6: VeriFactu Satellite",
    tasks: [
      {
        id: "6.1",
        name: "Sistema de firmas",
        status: "pending",
        description: "Facturas con firma digital según la nueva normativa española. Certificado digital para que sean legalmente válidas.",
        tech: "Crypto signatures",
        time: "2 semanas"
      },
      {
        id: "6.2",
        name: "Generación PDF",
        status: "pending",
        description: "Facturas en PDF profesionales: logo FIXARR, datos fiscales, desglose de IVA, código QR de verificación. Se ven genial.",
        tech: "React-PDF, jsPDF",
        time: "1 semana"
      },
      {
        id: "6.3",
        name: "Integración AEAT",
        status: "pending",
        description: "Conexión con Hacienda para envío automático de facturas según la nueva ley VeriFactu 2025. Cumplimiento normativo total.",
        tech: "AEAT API",
        time: "2-3 semanas"
      },
      {
        id: "6.4",
        name: "Registro operaciones",
        status: "pending",
        description: "Log inmutable de todas las operaciones de facturación. Para auditorías y cumplimiento legal. Nada se puede borrar o modificar.",
        tech: "Audit Logs",
        time: "1 semana"
      }
    ]
  },
  {
    name: "FASE 7: Legalización y Seguridad",
    tasks: [
      {
        id: "7.1",
        name: "GDPR completo",
        status: "pending",
        description: "Cumplimiento del Reglamento de Protección de Datos: consentimiento explícito, derecho al olvido, portabilidad de datos. Todo legal.",
        tech: "Legal implementation",
        time: "2 semanas"
      },
      {
        id: "7.2",
        name: "Cookies consent",
        status: "pending",
        description: "Banner de cookies según la ley: 'Aceptar todas' / 'Solo necesarias' / 'Configurar'. El popup que ves en todas las webs.",
        tech: "Cookie Manager",
        time: "3-5 días"
      },
      {
        id: "7.3",
        name: "Términos y condiciones",
        status: "pending",
        description: "Documento legal de condiciones del servicio: responsabilidades, garantías, disputas. Lo que el usuario acepta al usar FIXARR.",
        tech: "Legal document",
        time: "1 semana"
      },
      {
        id: "7.4",
        name: "Política privacidad",
        status: "pending",
        description: "Documento que explica qué datos recogemos, para qué los usamos, con quién los compartimos y los derechos del usuario.",
        tech: "Legal document",
        time: "1 semana"
      },
      {
        id: "7.5",
        name: "Auditoría seguridad",
        status: "pending",
        description: "Revisión completa de seguridad: que no se puedan hackear, robar datos o hacer cosas raras. Test de penetración profesional.",
        tech: "OWASP, Pen testing",
        time: "2 semanas"
      },
      {
        id: "7.6",
        name: "Backup automático",
        status: "pending",
        description: "Copias de seguridad automáticas diarias de toda la base de datos. Si algo falla, puedes restaurar todo en minutos.",
        tech: "pg_dump, S3",
        time: "3-5 días"
      },
      {
        id: "7.7",
        name: "Certificado SSL",
        status: "pending",
        description: "HTTPS en todo: el candadito verde que sale en el navegador. Renovación automática. Seguridad y confianza.",
        tech: "Let's Encrypt",
        time: "1 día"
      }
    ]
  },
  {
    name: "FASE 7.5: Auditoría y Pulido General",
    tasks: [
      {
        id: "7.5.1",
        name: "Testing exhaustivo",
        status: "pending",
        description: "Pruebas automáticas que verifican que TODO funciona: crear servicio, asignar técnico, enviar mensaje... Si algo se rompe, lo detectamos antes del usuario.",
        tech: "Jest, Cypress",
        time: "2 semanas"
      },
      {
        id: "7.5.2",
        name: "Revisión UX/UI",
        status: "pending",
        description: "Experto en diseño revisa la experiencia: ¿es fácil de usar? ¿se entiende? ¿los botones están donde deben? Pulir detalles.",
        tech: "UX Audit",
        time: "1 semana"
      },
      {
        id: "7.5.3",
        name: "Performance optimization",
        status: "pending",
        description: "Optimizar velocidad: que cargue rápido, que no se cuelgue, que funcione perfecto en móvil. Objetivo: 100 en PageSpeed.",
        tech: "Lighthouse",
        time: "1 semana"
      },
      {
        id: "7.5.4",
        name: "Documentación técnica",
        status: "pending",
        description: "Manual técnico para programadores: cómo funciona cada parte, cómo hacer cambios, dónde está cada cosa. Para el futuro.",
        tech: "Markdown, Swagger",
        time: "1-2 semanas"
      },
      {
        id: "7.5.5",
        name: "Manual de usuario",
        status: "pending",
        description: "Guía paso a paso para usuarios: cómo crear servicio, cómo asignar técnico, cómo ver reportes. Con capturas de pantalla.",
        tech: "Notion, PDF",
        time: "1 semana"
      },
      {
        id: "7.5.6",
        name: "Video tutoriales",
        status: "pending",
        description: "Vídeos cortos explicando cada función: 'Cómo crear un servicio', 'Cómo ver la agenda'. Para nuevos usuarios.",
        tech: "Loom, YouTube",
        time: "1-2 semanas"
      }
    ]
  },
  {
    name: "FASE 8: Nativización (Web → Apps Nativas)",
    tasks: [
      {
        id: "8.1",
        name: "Admin Panel iOS",
        status: "pending",
        description: "App nativa del panel de administración para iPhone/iPad. Mismas funciones que la web pero optimizada para Apple.",
        tech: "React Native / PWA",
        time: "4-6 semanas"
      },
      {
        id: "8.2",
        name: "Admin Panel Android",
        status: "pending",
        description: "App nativa del panel de administración para Android. Mismas funciones que la web pero optimizada para Android.",
        tech: "React Native / PWA",
        time: "4-6 semanas"
      },
      {
        id: "8.3",
        name: "Cliente iOS - App Store",
        status: "pending",
        description: "Publicar la app de clientes Flutter en App Store. Ya está desarrollada, falta subir a la tienda de Apple.",
        tech: "App Store Connect",
        time: "1-2 semanas"
      },
      {
        id: "8.4",
        name: "Cliente Android - Play Store",
        status: "pending",
        description: "Publicar la app de clientes Flutter en Google Play. Ya está desarrollada, falta subir a la tienda.",
        tech: "Play Console",
        time: "1 semana"
      },
      {
        id: "8.5",
        name: "Técnicos iOS - App Store",
        status: "pending",
        description: "Publicar la app de técnicos Flutter en App Store. Ya está desarrollada, falta subir a la tienda de Apple.",
        tech: "App Store Connect",
        time: "1-2 semanas"
      },
      {
        id: "8.6",
        name: "Técnicos Android - Play Store",
        status: "pending",
        description: "Publicar la app de técnicos Flutter en Google Play. Ya está desarrollada, falta subir a la tienda.",
        tech: "Play Console",
        time: "1 semana"
      },
      {
        id: "8.7",
        name: "Push Notifications nativas",
        status: "pending",
        description: "Notificaciones push en las apps móviles: nuevo servicio, técnico en camino, servicio completado. Funciona con app cerrada.",
        tech: "FCM, APNs",
        time: "1 semana"
      }
    ]
  },
  {
    name: "FASE 8.5: Professional PRO - Features B2B",
    tasks: [
      {
        id: "8.5.1",
        name: "Multi-empresa",
        status: "pending",
        description: "Soporte para franquicias o múltiples empresas. Cada empresa ve solo SUS datos, el superadmin ve todo. Mismo sistema, datos separados.",
        tech: "RLS per tenant",
        time: "2-3 semanas"
      },
      {
        id: "8.5.2",
        name: "Roles avanzados",
        status: "pending",
        description: "Permisos granulares: admin ve todo, coordinador solo agenda, técnico solo sus servicios. Configurable por módulo.",
        tech: "RBAC",
        time: "1-2 semanas"
      },
      {
        id: "8.5.3",
        name: "API pública",
        status: "pending",
        description: "API documentada para integrar FIXARR con otros sistemas: ERP, contabilidad, BI. Claves API, límites, versionado.",
        tech: "REST API, OAuth2",
        time: "2-3 semanas"
      },
      {
        id: "8.5.4",
        name: "Webhooks externos",
        status: "pending",
        description: "Notificar a sistemas externos cuando pasan cosas: nuevo servicio → tu ERP lo recibe. Pago recibido → tu contabilidad lo sabe.",
        tech: "Webhook system",
        time: "1 semana"
      },
      {
        id: "8.5.5",
        name: "White label",
        status: "pending",
        description: "Personalización completa: tu logo, tus colores, tu dominio. FIXARR como motor invisible. Para vender el sistema a otras empresas.",
        tech: "Theme system",
        time: "2 semanas"
      },
      {
        id: "8.5.6",
        name: "Analytics avanzado",
        status: "pending",
        description: "Métricas de empresa: comparativas entre técnicos, predicciones de demanda, alertas de rendimiento. Business Intelligence.",
        tech: "Charts, ML",
        time: "2 semanas"
      }
    ],
    isNew: true
  },
  {
    name: "FASE 9: Expansión B2B",
    tasks: [
      {
        id: "9.1",
        name: "Módulo B2B",
        status: "pending",
        description: "Funciones para empresas clientes: contratos de mantenimiento, precios especiales, facturación mensual, SLA garantizados.",
        tech: "Contract management",
        time: "3-4 semanas"
      },
      {
        id: "9.2",
        name: "Integración proveedores",
        status: "pending",
        description: "Conexión con proveedores de repuestos: cuando falta una pieza, pedido automático. Stock actualizado, precios en tiempo real.",
        tech: "EDI, API",
        time: "2-3 semanas"
      }
    ]
  }
];
